import React, { Component } from 'react';
import * as Questions from './questions'


export const Recommendations = (props) => {
    let relevantRecommendations = Questions.recommendationsForSubSection(props.subSection).filter(recommendation => recommendation)
    if (relevantRecommendations.length > 0) return (
        <div>
            <p>Para endereçar as oportunidades de melhoria, considere as iniciativas abaixo:</p>
            <ul>
            {
                relevantRecommendations.map( (recommendation, recommendationOffset)=> 
                    <li key={recommendationOffset}>
                        {recommendation && recommendation.title}
                    </li>
                )
            }
            </ul>
        </div>
    )
    else return (
        <p>Continue com o bom trabalho realizado até agora.</p>
    )
}


// WEBPACK FOOTER //
// ./src/Recommendations.jsx